import {ListMenu, MineMenu} from "@/api/menu";

const state = () => ({
  menus: [],
  mineMenus: [],
  subjects: [],
})

// getters
const getters = {
  plainRoutes: state => {
    let plainRoutes = []
    for (let sub of state.subjects) {
      if (!sub.routes) {
        continue
      }
      for (let route of sub.routes) {
        plainRoutes.push(route)
        if (route.children) {
          for (let child of route.children) {
            plainRoutes.push(child)
          }
        }
      }
    }
    return plainRoutes
  }
}

// actions
const actions = {
  async fetchMenus( { commit, dispatch } ) {
    await dispatch("loading/setLoading", true, {root: true})
    ListMenu().then((data) => {
      let menus = data.data.data
      menuTree(menus)
      commit('setMenus', menus)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async fetchMineMenus( { commit, dispatch } ) {
    await dispatch("loading/setLoading", true, {root: true})
    MineMenu().then((data) => {
      let menus = data.data.data
      commit('setMineMenus', menus)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  setSubjects({commit}, payload) {
    console.log("store", payload)
    commit('setSubjects', payload)
  }
}

function menuTree(menus) {
  if (menus !== undefined) {
    for (let menu of menus) {
      menu.title = menu.menu_name
      if (menu.children) {
        menuTree(menu.children)
      }
    }
  }
}

// mutations
const mutations = {
  setMenus (state, menus) {
    state.menus = menus
  },
  setMineMenus (state, menus) {
    state.mineMenus = menus
  },
  setSubjects (state, subjects) {
    state.subjects = subjects
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
